(() => {
  const init = (root) => {
    if (root.dataset.photoReviewsReady) return;
    root.dataset.photoReviewsReady = 'true';
    const cards = [...root.querySelectorAll('[data-photo-review]')];
    const filter = root.querySelector('[data-photo-review-filter]');
    const prev = root.querySelector('[data-photo-review-prev]');
    const next = root.querySelector('[data-photo-review-next]');
    const status = root.querySelector('[data-photo-review-status]');
    const pageLabel = root.querySelector('[data-photo-review-page]');
    const dialog = root.querySelector('[data-photo-review-zoom]');
    const zoomImage = root.querySelector('[data-photo-review-zoom-image]');
    let page = 0;
    const size = 8;
    let filtered = cards;
    let photoTrigger;
    const render = (move = false) => {
      const pages = Math.max(1, Math.ceil(filtered.length / size));
      page = Math.max(0, Math.min(page, pages - 1));
      const visible = new Set(filtered.slice(page * size, (page + 1) * size));
      cards.forEach(card => { card.hidden = !visible.has(card); });
      prev.disabled = page === 0;
      next.disabled = page >= pages - 1;
      status.textContent = `${filtered.length ? page * size + 1 : 0}–${Math.min((page + 1) * size, filtered.length)} / ${filtered.length}`;
      pageLabel.textContent = `${page + 1} / ${pages}`;
      if (move) root.querySelector('.photo-reviews-tools').scrollIntoView({ block: 'start', behavior: 'instant' });
    };
    filter.addEventListener('change', () => {
      filtered = filter.value === 'all' ? cards : cards.filter(card => card.dataset.rating === filter.value);
      page = 0;
      render();
    });
    prev.addEventListener('click', () => { page--; render(true); });
    next.addEventListener('click', () => { page++; render(true); });
    root.addEventListener('click', event => {
      const button = event.target.closest('[data-review-photo]');
      if (!button || !root.contains(button)) return;
      photoTrigger = button;
      const image = button.querySelector('img');
      zoomImage.src = image.currentSrc || image.src;
      zoomImage.alt = image.alt;
      dialog.showModal();
    });
    root.querySelector('[data-photo-review-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => { zoomImage.removeAttribute('src'); photoTrigger?.focus(); });
    render();
  };
  document.querySelectorAll('[data-photo-reviews]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-photo-reviews]').forEach(init));
})();
